"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataGridMobileRowRenderer = exports.dataGridDesktopRowRenderer = void 0;
var DataGridDesktopRowRenderer_1 = require("./DataGridDesktopRowRenderer");
Object.defineProperty(exports, "dataGridDesktopRowRenderer", { enumerable: true, get: function () { return __importDefault(DataGridDesktopRowRenderer_1).default; } });
var DataGridMobileRowRenderer_1 = require("./DataGridMobileRowRenderer");
Object.defineProperty(exports, "dataGridMobileRowRenderer", { enumerable: true, get: function () { return __importDefault(DataGridMobileRowRenderer_1).default; } });
